export const visit = (vm, at) => {
vm(require("foundations-components/lang/hi.lyaml"));
at({ "hi": { "placeholder": "\u092A\u094D\u0932\u0947\u0938\u0939\u094B\u0932\u094D\u0921\u0930" } });
};